
import { createRouter, createWebHistory } from 'vue-router';
import login from './views/login.vue';
import chat from './views/chat.vue';
import doctor from './views/doctor.vue';
import doctors from './views/doctors.vue';
import Home from './views/home.vue';
import Xiaofu from './views/xiaofu.vue';
import Mingyi from './views/mingyi.vue';
import Zhuanbing from './views/zhuanbing.vue';
import Zhuanyao from './views/zhuanyao.vue';
import Pill from './views/pill.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/chat',
    name: 'chat',
    component: chat,
  },
  {
    path: '/ai-doctors',
    name: 'doctors',
    component: doctors,
  },
  {
    path: '/ai-doctor',
    name: 'doctor',
    component: doctor,
  },
  {
    path: '/xiaofu',
    name: 'xiaofu',
    component: Xiaofu,
  },
  {
    path: '/zhuanbing',
    name: 'zhuanbing',
    component: Zhuanbing,
  },
  {
    path: '/zhuanyao',
    name: 'zhuanyao',
    component: Zhuanyao,
  },
  {
    path: '/mingyi',
    name: 'mingyi',
    component: Mingyi,
  },
  {
    path: '/pill',
    name: 'pill',
    component: Pill,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
];

const router = createRouter({
  history: createWebHistory(), // 使用 history 模式
  routes,
});

router.beforeEach((to, from, next) => {
  console.log('Navigating to:', to);

  const token = localStorage.getItem('authToken');
  
  if (['/login'].includes(to.path) && token) {
    // 已登录，禁止访问登录页，跳转到 redirect 参数指定的页面或首页
    const redirect = to.query.redirect || '/';
    next(redirect);
  } else if (!token && !['/login', '/'].includes(to.path)) {
    // 未登录，跳转到登录页，并携带当前页面路径作为 redirect 参数
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

export default router;
